import { t } from "@/i18n-js/instance";
import type { ViewSwitcherLayoutOptions } from "@circle-react-shared/ViewSwitcher";

export const EVENT_TYPES = {
  UPCOMING: "upcoming",
  PAST: "past",
  DRAFT: "draft",
};

export const EVENT_LAYOUT_TYPES = {
  POSTS: "posts",
  THUMBNAIL: "thumbnail",
  CALENDAR: "calendar",
} as const;

export const EVENT_LAYOUT_OPTIONS: ViewSwitcherLayoutOptions[] = [
  {
    icon: "16-thumbnail-layout",
    label: t("all_events.views.default_layout_thumbnail"),
    value: EVENT_LAYOUT_TYPES.THUMBNAIL,
  },
  {
    icon: "bullet-list-text",
    label: t("all_events.views.default_layout_list"),
    value: EVENT_LAYOUT_TYPES.POSTS,
  },
  {
    icon: "16-calendar",
    label: t("all_events.views.default_layout_calendar"),
    value: EVENT_LAYOUT_TYPES.CALENDAR,
  },
];

export const EVENT_LAYOUT_ADMIN_OPTIONS: ViewSwitcherLayoutOptions[] = [
  {
    icon: "16-thumbnail-layout",
    label: t("all_events.admin_views.thumbnail"),
    value: EVENT_LAYOUT_TYPES.THUMBNAIL,
  },
  {
    icon: "bullet-list-text",
    label: t("all_events.admin_views.list"),
    value: EVENT_LAYOUT_TYPES.POSTS,
  },
  {
    icon: "16-calendar",
    label: t("all_events.admin_views.calendar"),
    value: EVENT_LAYOUT_TYPES.CALENDAR,
  },
];

export const EVENT_VIEW_DISPLAY_VALUES: any = {
  posts: "list",
  thumbnail: "thumbnail",
  calendar: "calendar",
};
